import React from 'react';
import { Button as OrigButton, ButtonProps, Loader } from '@wheely/ui-kit';
import cn from 'classnames';

import s from './styles.module.css';

interface IProps extends ButtonProps {
  isPending?: boolean;
  isDisabled?: boolean;
  disabled?: never;
  children?: React.ReactNode;
}

const Button = (props: IProps) => {
  const { isPending, isDisabled, className, disabled, children, ...rest } = props;

  return (
    <OrigButton
      className={cn(s.button, className, { [s.hasLoader]: isPending !== undefined })}
      disabled={isDisabled || isPending}
      {...rest}
      data-test-id="button"
    >
      {isPending ? <Loader className={s.loader} /> : children}
    </OrigButton>
  );
};

export type { IProps };
export { Button };
